import styled from 'styled-components';

export const Container = styled.div`
	padding: 16px;

	& > .ant-card {
		margin: 12px 0;
	}
`;

export const InputContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	& > * {
		width: 450px;
		max-width: 100%;
	}
`;

export const ScriptConfigContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: 0 80px;

	& > form,
	.ant-tabs {
		width: 100%;
	}
`;

export const ButtonContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;
